import { Button, Col, Row } from "antd";
import TextInput from "../inputs/TextInput";
import SelectInput from "../inputs/SelectInput";
import DateInput from "../inputs/DateInput";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getLocalStorage } from "../../helpers/localstorage";
import { confirmationStatus, DeliveryCompaniesConst, confirmationRoles, rolesConst } from "../../constants/others";
import { getData } from "../../helpers/api";
import FieldArrayInput from "../inputs/FieldArray";

const FormInputs = (props) => {
    const { initialValue } = props
    const cities = useMemo(() => getLocalStorage("bmdCities") || [], [])
    const confirmationStatusOptions = useMemo(() => confirmationStatus.map((el) => ({ label: el, value: el })), [])
    const [products, setProducts] = useState([])
    const [deliveryCompanies, setDeliveryCompanies] = useState([])
    const [deliveryCompaniesAccounts, setDeliveryCompaniesAccounts] = useState([])
    const [selectedDeliveryCompaniesAccounts, setselectedDeliveryCompaniesAccounts] = useState([])
    const [deliveryMen, setDeliveryMen] = useState([]);

    const getProducts = async () => {
        try {
            const user = getLocalStorage("auth")?.user;
            if ([...confirmationRoles, rolesConst.Management].includes(user?.role)) {
                // For roles that need product filtering, get allowed products
                const res = await getData(`/users/${user.id}/allowed-products`);
                setProducts(res.data.map((product) => ({ value: product.id, label: product.name })));
            } else {
                // For other roles (like super admin), get all products
                const res = await getData("/products");
                setProducts(res.data.map((product) => ({ value: product.id, label: product.name })));
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getDeliveryMen = async () => {
        try {
            const res = await getData("/users/deliverymen")
            setDeliveryMen(res.data.map((deliveryMan) => ({ value: deliveryMan.id, label: deliveryMan.name })))
        } catch (error) {
            console.log("error fetching delivery men")
        }
    }
    useEffect(() => {
        getProducts()
        getDeliveryCompanies()
        getDeliveryMen()
    }, [])


    const getDeliveryCompanies = async () => {
        try {
            const { data } = await getData("/users/delivery/companies/accounts")
            setDeliveryCompanies(data.deliveryCompanies.map((el) => ({ label: el.name, value: el.id })))
            setDeliveryCompaniesAccounts(data.deliveryCompanyKeys.map((el) => ({ label: el.name, value: el.id, deliveryCompanyId: el.deliveryCompany.id })))
        } catch (error) {
            console.log(error)
        }
    }

    const handleDeliveryCompanies = useCallback((value) => {
        console.log(value)
        console.log(deliveryCompaniesAccounts)
        const selectedDeliveryCompany = deliveryCompanies.find((el) => el.value === value);
        if (selectedDeliveryCompany.label === DeliveryCompaniesConst.DeliveryMen) {
            setselectedDeliveryCompaniesAccounts(deliveryMen);
        } else {
            setselectedDeliveryCompaniesAccounts(deliveryCompaniesAccounts.filter((el) => el.deliveryCompanyId === value))
        }
    },[deliveryCompanies, deliveryCompaniesAccounts, deliveryMen])

    useEffect(() => {
        if(initialValue.edit && deliveryCompanies.length) {
            handleDeliveryCompanies(initialValue.deliveryCompany);
        }
    }, [deliveryCompanies.length, initialValue.deliveryCompany, initialValue.edit, handleDeliveryCompanies]);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px"
            }}
        >
            <Row gutter={[8, 8]}>
                <Col lg={16} xs={15}>
                    <Row gutter={[8, 8]}>
                        <Col lg={12} md={12} sm={24} xs={24}>
                            <DateInput
                                name="orderDate"
                                placeholder="Date de la commande"
                                size="large"
                            />
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                            <SelectInput
                                name="confimationStatus"
                                size="large"
                                placeholder={"Statut"}
                                options={confirmationStatusOptions}
                                disabled
                            />
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                            <TextInput
                                name="name"
                                placeholder="Nom"
                                size="large"
                            />
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                            <TextInput
                                name="phone"
                                placeholder="Téléphone"
                                size="large"
                            />
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                            <TextInput
                                name="price"
                                placeholder="Prix"
                                size="large"
                                type="number"
                            />
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                            <SelectInput
                                name="bmdCity"
                                size="large"
                                placeholder={"Ville"}
                                options={cities.map((city) => ({ value: city.id, label: city.name }))}
                                disabled={initialValue.edit}
                            />
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                            <SelectInput
                                name="deliveryCompany"
                                size="large"
                                placeholder={"Société de livraison"}
                                options={deliveryCompanies}
                                onChangeValue={handleDeliveryCompanies}
                                disabled={initialValue.edit}
                            />
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                            <SelectInput
                                name="deliveryCompanyKey"
                                size="large"
                                placeholder={"Compte de livraison"}
                                options={selectedDeliveryCompaniesAccounts}
                                disabled={initialValue.edit}
                            />
                        </Col>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <TextInput
                                name="address"
                                placeholder="Adresse"
                                size="large"
                            />
                        </Col>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <TextInput
                                name="content"
                                placeholder="Note"
                                size="large"
                            />
                        </Col>
                    </Row>
                </Col>
                <Col lg={8} sm={8} xs={8}>
                    <FieldArrayInput
                        name="orders"
                        fieldToAdd={{
                            product: undefined,
                            unit: null
                        }}
                        allowFirstInput={true}
                        renderInput={(index) => (
                            <Row gutter={[8, 8]}>
                                <Col xs={24} md={24} lg={12}>
                                    <SelectInput
                                        name={`orders[${index}].product`}
                                        size="large"
                                        placeholder={"Produit"}
                                        options={products}
                                        disabled={initialValue.edit}
                                    />
                                </Col>
                                <Col xs={24} md={24} lg={12}>
                                    <TextInput
                                        name={`orders[${index}].unit`}
                                        placeholder="Unité"
                                        size="large"
                                        type="number"
                                        disabled={initialValue.edit}
                                    />
                                </Col>
                            </Row>
                        )}
                    />
                </Col>
            </Row>
            <Button size='large' type="primary" htmlType="submit">
                {initialValue.id ? "Mis a jour la cammande" : "Ajouter la commande"}
            </Button>
        </div>
    );
}

export default FormInputs;